import { render, staticRenderFns } from "./ExaminationCard.vue?vue&type=template&id=30a4adae"
import script from "./ExaminationCard.vue?vue&type=script&lang=js"
export * from "./ExaminationCard.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports